import React, { useState, useEffect } from 'react';
import { FormInstance } from 'antd/es/form';
import { UploadFile } from 'antd/es/upload/interface';
import { UploadChangeParam } from 'antd/lib/upload/interface';
import Configs from 'config';
import { get, map } from 'lodash';
import { getSampleImages } from 'libs/api/user';
import { useDataApi } from 'libs/hooks';
import { TUser } from 'modules/user';
import { CUploadImageProps } from 'constants/base.const';
import { CUserType, CUserTypeColor } from 'constants/user.const';
import { EUserType } from 'enums/base.enum';
import { Tag, Upload, message, Col, Row } from 'antd';
import ImgCrop from 'antd-img-crop';
import { EditOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { PrimaryColor, LightGrayColor } from 'GlobalStyles';

const ProfileImageWrapper = styled.div`
  margin-top: 10px;

  .ant-upload.ant-upload-select-picture-card {
    background: transparent;
    padding: 0px;
    border: none;
    order: 1;
  }
  .ant-upload img,
  .ant-upload .empty {
    background: ${LightGrayColor};
    border-radius: 50%;
    width: 100px;
    height: 100px;
    position: relative;
  }
  .small-img {
    margin: 1px;
    vertical-align: top;
    width: 50px;
    height: 50px;
    background: ${LightGrayColor};
    border-radius: 50%;
    display: inline-block;
    position: relative;
    border: 1px solid ${LightGrayColor};
  }
  img.small-img {
    cursor: pointer;
  }
  .anticon-edit {
    width: 25px;
    height: 25px;
    line-height: 25px;
    top: -25px;
    display: block;
    color: #fff;
    background-color: ${PrimaryColor};
    border-radius: 50%;
    float: right;
    position: relative;
  }
  .ant-upload.ant-upload-select-picture-card > .ant-upload {
    padding: 0px;
    display: inline-block !important;
  }
`;
type UploadFileListProps = {
  handleUpdateProfileImage?: any;
  onChange?: (value: UploadFile[]) => void;
  user?: TUser;
  imageId?: string | number;
  imageUrl?: string;
  form?: FormInstance;
};
const ProfileImageList = ({
  handleUpdateProfileImage,
  onChange,
  user,
  imageId,
  imageUrl,
  form,
}: UploadFileListProps) => {
  const [{ data: imageSampleList, loading }] = useDataApi<UploadFile[]>(getSampleImages.bind(null));
  const [previewImage, setPreviewImage] = useState<UploadFile>({
    status: 'done',
    response: {
      uid: imageId,
      absolute_url: imageUrl,
    },
  } as any);
  const userType = user ? get(user, 'user_type', EUserType.Mentee) : null;

  function triggerChange(changedValue: UploadFile[]) {
    onChange && onChange(changedValue);
  }

  function onValueChange(v: UploadFile[]) {
    triggerChange(v);
  }

  useEffect(() => {
    if (previewImage) {
      onValueChange([previewImage]);
      form && form.setFields([{ name: 'profile_images', value: [previewImage] }]);
    }
  }, [previewImage]);

  //preview 이미지 변경 시 '사진 변경'버튼 누르지 않고 자동 업데이트
  useEffect(() => {
    !!handleUpdateProfileImage && handleUpdateProfileImage();
  }, [form && form.getFieldValue('profile_images')]);

  return (
    <ProfileImageWrapper>
      <Row gutter={20} justify='space-around'>
        <Col flex='100px'>
          <ImgCrop rotate modalTitle='업로드'>
            <Upload
              {...CUploadImageProps}
              name='profile_image'
              action={`${Configs.API_HOST}/user/profile_image`}
              onChange={(info: UploadChangeParam) => {
                if (info.file.status === 'error') {
                  message.error('이미지 업로드에 실패했습니다');
                }
                if (info.file.status === 'done') {
                  setPreviewImage(info.file);
                }
              }}
            >
              {get(previewImage, 'response.absolute_url') ? (
                <img alt='profile_image' src={`${get(previewImage, 'response.absolute_url')}`} />
              ) : (
                <div className='empty' />
              )}
              <EditOutlined />
              {userType && (
                <Tag className='user-type-tag' color={CUserTypeColor[userType]}>
                  {CUserType[userType]}
                </Tag>
              )}
            </Upload>
          </ImgCrop>
        </Col>
        <Col flex='auto' style={{ textAlign: 'center', maxWidth: '300px' }}>
          {map(imageSampleList, (image) => (
            <img
              alt='sample_image'
              className='small-img'
              src={get(image, 'absolute_url')}
              onClick={() => {
                setPreviewImage({
                  status: 'done',
                  response: {
                    id: get(image, 'id'),
                    absolute_url: get(image, 'absolute_url'),
                  },
                } as UploadFile);
              }}
            />
          ))}
        </Col>
      </Row>
    </ProfileImageWrapper>
  );
};

export default ProfileImageList;
